import { Box, Typography } from '@mui/material';
import { useTheme } from "@mui/material/styles";
import { ErrorColorsType, errorColors } from "../utils/colorHelpers";

export interface ReportLegendProps {
    showSuccess?: boolean;
}

const ReportLegend = (showSuccess = false) => {
    const theme = useTheme();

    const legendBox = (title: string, status: string) => {

        const colors: ErrorColorsType = errorColors(theme, status);
        return (
            <>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0, p: 1 }}>
                    <Typography variant="caption" whiteSpace="pre-wrap">
                        {title}
                    </Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0, backgroundColor: `${colors.backgroundColor}`, border: `2px solid ${colors.borderColor}`, p: 1, maxHeight: 6 }}>
                    <Typography variant="caption" whiteSpace="pre-wrap" sx={{ color: `${colors.textColor}` }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    </Typography>
                </Box>
            </>
        )
    };

    return (
        <Box sx={{
            display: "flex", flexDirection: "row", gap: 0, alignItems: "center", pr: 2, mr: 2, border: `1px solid ${theme.palette.divider}`,
        }}>
            {showSuccess && legendBox("Success", "success")}
            {legendBox("Fail", "error")}
            {legendBox("Unavailable", "unavailable")}
            {legendBox("Offline", "offline")}
        </Box>
    );
};

export default ReportLegend;
